const MANIFEST_STYLES = {
    utility: {
        hashed: 'utility.9ce5c4f47263342fc281c47aace9a8b1.min.css',
        versioned: 'utility.min.css'
    },
    core: {
        hashed: 'core.277a4effb127f23b57897200f1b9b151.min.css',
        versioned: 'core.min.css'
    },
    zoomControls: {
        hashed: 'zoom-controls.9c87f956af940730852c6639a6b5641b.min.css',
        versioned: 'zoom-controls.min.css'
    },
    visible: {
        hashed: 'visible.388bb400607befa65ff09c5a81d28b7f.min.css',
        versioned: 'visible.min.css'
    },
    toggleSwitch: {
        hashed: 'toggle-switch.b324430baf9c1672a31592f7f21b60a8.min.css',
        versioned: 'toggle-switch.min.css'
    },
    thumbnailsHero: {
        hashed: 'thumbnails-hero.3329bc13a9de0f074327d5d316d1d32e.min.css',
        versioned: 'thumbnails-hero.min.css'
    },
    tabs: {
        hashed: 'tabs.6787c30c15f3f2d8d51d6bc347d383ec.min.css',
        versioned: 'tabs.min.css'
    },
    table: {
        hashed: 'table.f9f5fa35f1583a63aac14510540f70ac.min.css',
        versioned: 'table.min.css'
    },
    stepIndicator: {
        hashed: 'step-indicator.8bea8cf932ac4329b5a839ce44999de7.min.css',
        versioned: 'step-indicator.min.css'
    },
    standardTile: {
        hashed: 'standard-tile.cd1e163516d233d5ae3be8e07b5908a1.min.css',
        versioned: 'standard-tile.min.css'
    },
    standardHero: {
        hashed: 'standard-hero.b3c1a491ec7d82c4d1de9c62525d9e27.min.css',
        versioned: 'standard-hero.min.css'
    },
    standardBanner: {
        hashed: 'standard-banner.76bc30b36139633dd673a261ac2d9d3e.min.css',
        versioned: 'standard-banner.min.css'
    },
    spinner: {
        hashed: 'spinner.19af20e424ada281621b990b29a23f57.min.css',
        versioned: 'spinner.min.css'
    },
    selectionSet: {
        hashed: 'selection-set.47df424d7761c6384c5cd9698322e648.min.css',
        versioned: 'selection-set.min.css'
    },
    secondaryTile: {
        hashed: 'secondary-tile.c06e97649b2664c9b1240a8f9641dd4d.min.css',
        versioned: 'secondary-tile.min.css'
    },
    ratingsStars: {
        hashed: 'ratings-stars.765b21f1d1b20b188f366da8ceabc1c4.min.css',
        versioned: 'ratings-stars.min.css'
    },
    promoBar: {
        hashed: 'promo-bar.a4229c4e42c9cbf2cf292444f86e4ddf.min.css',
        versioned: 'promo-bar.min.css'
    },
    progressiveImage: {
        hashed: 'progressive-image.f0a54c9123842f31dd3ce49ef0961118.min.css',
        versioned: 'progressive-image.min.css'
    },
    progressBar: {
        hashed: 'progress-bar.43a70e3abf66fcfe184e39306f6d3797.min.css',
        versioned: 'progress-bar.min.css'
    },
    pricing: {
        hashed: 'pricing.5bd74032196cd8df893b87a8016f7fb3.min.css',
        versioned: 'pricing.min.css'
    },
    priceBar: {
        hashed: 'price-bar.eae520979569aa6127b370a3992029d6.min.css',
        versioned: 'price-bar.min.css'
    },
    popover: {
        hashed: 'popover.9e1957a443640b326d838e550919ecad.min.css',
        versioned: 'popover.min.css'
    },
    pagination: {
        hashed: 'pagination.82d7f842de68d2575de76785111c897c.min.css',
        versioned: 'pagination.min.css'
    },
    modalDialog: {
        hashed: 'modal-dialog.d183201634543036ed1951edc394e75d.min.css',
        versioned: 'modal-dialog.min.css'
    },
    menu: {
        hashed: 'menu.818a0900b92cbef02394b26d263bb1ae.min.css',
        versioned: 'menu.min.css'
    },
    listbox: {
        hashed: 'listbox.5fab46ce54853e1d3cd72045ddd36b50.min.css',
        versioned: 'listbox.min.css'
    },
    legacyPopover: {
        hashed: 'legacy-popover.75a905ca99892ad5f0b58f21af88bc0c.min.css',
        versioned: 'legacy-popover.min.css'
    },
    legacyModalDialog: {
        hashed: 'legacy-modal-dialog.c0f488987db84970fef0af293ba22492.min.css',
        versioned: 'legacy-modal-dialog.min.css'
    },
    legacyListbox: {
        hashed: 'legacy-listbox.83e1b677017ef217f83b758a544cf51b.min.css',
        versioned: 'legacy-listbox.min.css'
    },
    legacyCombobox: {
        hashed: 'legacy-combobox.cb1789f3ca06194258114a6c8d0d0b19.min.css',
        versioned: 'legacy-combobox.min.css'
    },
    icon: {
        hashed: 'icon.de0c3f374d63ed3869be4238010afb64.min.css',
        versioned: 'icon.min.css'
    },
    hidden: {
        hashed: 'hidden.90549d732670d4ba02fac0dc001a0bb8.min.css',
        versioned: 'hidden.min.css'
    },
    grid: {
        hashed: 'grid.68bc92ecd3e784f68cba66cf565ab57e.min.css',
        versioned: 'grid.min.css'
    },
    fieldSet: {
        hashed: 'field-set.b4b1adfeffa5420eb5d5f1e46900d413.min.css',
        versioned: 'field-set.min.css'
    },
    embeddedTextHero: {
        hashed: 'embedded-text-hero.c16a5e17e2487ffc4a4c616e7111d6c9.min.css',
        versioned: 'embedded-text-hero.min.css'
    },
    detailsBanner: {
        hashed: 'details-banner.4ae73a272f89095f48bf5cd8aec94acf.min.css',
        versioned: 'details-banner.min.css'
    },
    controlIcon: {
        hashed: 'control-icon.1be7da330ecf24ecf63997a73b5d299b.min.css',
        versioned: 'control-icon.min.css'
    },
    combobox: {
        hashed: 'combobox.6ed8b931ac7e89e55e420f2d8a10b783.min.css',
        versioned: 'combobox.min.css'
    },
    carousel: {
        hashed: 'carousel.594417d1909741a2cb3eaccd7faab781.min.css',
        versioned: 'carousel.min.css'
    },
    button: {
        hashed: 'button.41fb8316e0d29e102e44d9dfff2eaf74.min.css',
        versioned: 'button.min.css'
    },
    banner: {
        hashed: 'banner.23b6e3ad2299a1ca8339f0efe492c217.min.css',
        versioned: 'banner.min.css'
    },
    anchorBar: {
        hashed: 'anchor-bar.b40b5a53e5fd257a8af66adb0b6b9426.min.css',
        versioned: 'anchor-bar.min.css'
    },
    alertBox: {
        hashed: 'alert-box.639a4529f1f05a413ab15cccf33850c6.min.css',
        versioned: 'alert-box.min.css'
    },
    accordion: {
        hashed: 'accordion.284a13988fa5cc37e86fa4b066d7439d.min.css',
        versioned: 'accordion.min.css'
    }
};

export { MANIFEST_STYLES };
